export const copy = {
  companyName: "seasmoke labs",
  homeHeader: "home",
  homeTitle: "an independent software and design agency",
  homeText:
    "Custom software development is our key area of expertise. We develop complex interactive web experiences from design to deployment.",
  ourWorkHeader: "our work",
  ourWorkCompany1Name: "PHAR partnerships",
  ourWorkCompany1Description:
    "Bespoke internal database and UI for commercial information with export-to-Powerpoint functionality.",
  ourWorkCompany2Name: "Quali-Service",
  ourWorkCompany2Description:
    "End-to-end web application for small business customer surveys and reputation management.",
  ourWorkCompany3Name: "TMG",
  ourWorkCompany3Description:
    "Marketing site and integrated booking tool for events company.",
  contactHeader: "contact",
  contactButton: "Get in touch",
  contactUs: "If you're interested in working with us, please send an email to",
  contactEmail: "contact@seasmoke.io",
};
